import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { H1, Paragraph, Text } from 'components/core/Typography';

import './InformedSearchHeader.scss';

export default function InformedSearchHeader({
	className,
	location
}) {
	return (
		<div className={classnames('informed-search-header', className)}>
			<H1 size="large">
				Self-storage facilities centered
				around {location.city}, {location.state} {location.zip ? ` (${location.zip})` : ''}
			</H1>
			<Paragraph size="small">
				How it works
			</Paragraph>
			<ol className="steps">
				<li className="step">
					<span className="number">1</span><Text>Select your unit</Text>
				</li>
				<li className="step">
					<span className="number">2</span><Text>Reserve for free</Text>
				</li>
				<li className="step">
					<span className="number">3</span><Text>Visit your facility</Text>
				</li>
				<li className="step">
					<span className="number">4</span><Text>Move in</Text>
				</li>
			</ol>
		</div>
	);
}

InformedSearchHeader.propTypes = {
	className: PropTypes.string,
	location: PropTypes.shape({
		city: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired,
		zip: PropTypes.string
	}).isRequired
};
